import React, { useState, useEffect, useRef } from 'react';
import { fetchHtml } from '../../../helpers/fetch.js';
import LoadingIndicator from '../loading_indicator.jsx';
import { Row, Col } from '../../bootstrap/index.jsx';

const Preview = ({actionParams, action, queryParams={}}) => {
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!actionParams || !actionParams.current) return;
    setLoading(true)
    iframeRef.current.src = "about:blank";
    queryParams['preview'] = true;
    const queryStr = '?' + new URLSearchParams(queryParams).toString();
    fetchHtml(action + queryStr, {
      body: JSON.stringify(actionParams.current), 
      method: 'post',}).then(res => {
      let iframeDoc = iframeRef.current.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(res);
      iframeDoc.close();
      // Poll for the finished element
      const checkForFinished = () => {
        const finishedElement = iframeDoc.getElementById('pdf-generation-finished');
        if (finishedElement) {
          setLoading(false);
        } else {
          setTimeout(checkForFinished, 100);
        }
      };
      
      // Start checking after a brief delay
      setTimeout(checkForFinished, 100);
     }
    , [actionParams])

    // const u = encodeURIComponent(JSON.stringify(actionParams.current));
    // iframeRef.current.src = action + (action.includes('?') ? '&' : '?') + 'preview&content=' + u;
    // jQuery(iframeRef.current).on('load', function () { setLoading(false) })

    // Set the iframe's new HTML
  },[actionParams])

  return <>
  { loading &&
    <Row>
      <Col>
        <LoadingIndicator 
          asOverlay={true} 
          additionalInfo={I18n.t('generating_preview')}
          overlayClasses='loading-indicator-pdf-preview' />
      </Col>
    </Row>}
  <iframe ref={iframeRef} src='#' className='pdf-preview'/>
  </>
}

export default Preview;